/**
** JAVASCRIPTS
** Name: Finder
********************************************************************************/

(function() {


  if(document.querySelector('.js-finder') && document.querySelectorAll('.js-finder-item').length > 0) {


    /**
    ** Variables
    ****************************************/

    const $finder = document.querySelector('.js-finder');


    /**
    ** FUNCTION
    ** Set Map
    ****************************************/

    function setMap() {


      /**
      ** Variables
      ****************************************/

      const $items    = $finder.querySelectorAll('.js-finder-item');
      const $map      = document.getElementById('map');
      const iconUrl   = $map.dataset.marker;
      const activeUrl = $map.dataset.active;

      const scrollOffset = 15;

      var markerIcon = L.icon({
        iconUrl:      iconUrl,
        shadowUrl:    false,
        iconSize:     [40, 40],
        shadowSize:   [0, 0],
        iconAnchor:   [20, 39],
        shadowAnchor: [0, 0],
        popupAnchor:  [0, -40]
      });

      var activeIcon = L.icon({
        iconUrl:      activeUrl,
        shadowUrl:    false,
        iconSize:     [40, 40],
        shadowSize:   [0, 0],
        iconAnchor:   [20, 39],
        shadowAnchor: [0, 0],
        popupAnchor:  [0, -40]
      });

      var popupOptions = {
        'maxWidth': '330',
        'width': '280'
      }

      var map     = L.map('map', {scrollWheelZoom: false}).setView([48.8588897, 2.320041], 13);
      var markers = [];


      /**
      ** Set tiles
      ***************************************/

      var OpenStreetMap_Mapnik = L.tileLayer('//{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
        attribution: 'donn&eacute;es &copy; <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - Tiles courtesy of <a href="https://hot.openstreetmap.org/">Humanitarian OpenStreetMap Team</a>',
        minZoom: 4,
        maxZoom: 13
      });

      OpenStreetMap_Mapnik.addTo(map);


      /**
      ** ACTION
      ** Create markers
      ***************************************/

      $items.forEach(function($item) {
        const lat  = $item.dataset.lat;
        const lng  = $item.dataset.lng;
        const slug = $item.dataset.slug;

        var $content = $item.cloneNode(true);

        $content.classList.remove('js-finder-item');
        $content.classList.remove('c-finder__item');
        $content.classList.add('c-finder__window');

        var marker = L.marker([lat, lng], {icon: markerIcon, slug: slug}).addTo(map);
        marker.bindPopup($content, popupOptions);

        markers.push(marker);

        // $item.addEventListener('mouseover', function(e) {
        //   marker.setIcon(activeIcon);
        // });

        // $item.addEventListener('mouseout', function(e) {
        //   marker.setIcon(markerIcon);
        // });
      });


      /**
      ** ACTION
      ** Map fit bounds
      ***************************************/

      if(markers.length > 0) {
        var markersGroup = new L.featureGroup(markers);
        map.fitBounds(markersGroup.getBounds());
      }


      /**
      ** ACTION
      ** On popup open / close
      ***************************************/

      map.on('popupopen', function(e) {
        const marker = e.popup._source;
        const slug   = marker.options.slug;
        const $item  = document.querySelector('.js-finder-item[data-slug="' + slug + '"]');
        const offset = $item.offsetTop - scrollOffset;

        marker.setIcon(activeIcon);

        // $item.classList.add('is-active');
      });

      map.on('popupclose', function(e) {
        var marker = e.popup._source;
        var slug   = marker.options.slug;
        var $item  = document.querySelector('.js-finder-item[data-slug="' + slug + '"]');

        marker.setIcon(markerIcon);
        // $item.classList.remove('is-active');
      });


      // $finder.classList.add('map-active');


    }


    /**
    ** Init
    ****************************************/

    // if(window.innerWidth >= 960) {
      setMap();
    // }


  }

})();
